/**
 * SP グローバルドロワーメニュー（全ページ共通）
 * FC は PC/SP 各ヘッダーに [data-action="toggle-menu-open"] があるためイベント委譲で処理。
 */
(function () {
  'use strict';

  if (window.__nigamiDrawerMenuInit) return;
  window.__nigamiDrawerMenuInit = true;

  function getDrawer() {
    return document.getElementById('sp-global-drawer-menu');
  }

  function getOpenButtons() {
    return document.querySelectorAll('[data-action="toggle-menu-open"]');
  }

  function getCloseButton() {
    var drawer = getDrawer();
    if (!drawer) return null;
    return drawer.querySelector('[data-action="toggle-menu-close"]');
  }

  function focusFirstVisibleOpenButton() {
    var openBtns = getOpenButtons();
    var visible = Array.prototype.filter.call(openBtns, function (btn) {
      return btn.offsetParent !== null;
    });
    var target = visible[0] || openBtns[0];
    if (target) target.focus();
  }

  function setOpen(open) {
    var drawer = getDrawer();
    if (!drawer) return;

    var openBtns = getOpenButtons();
    var closeBtn = getCloseButton();

    if (open) {
      drawer.removeAttribute('hidden');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('menu-open');
      openBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'true');
      });
      if (closeBtn) closeBtn.focus();
    } else {
      drawer.setAttribute('hidden', '');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('menu-open');
      openBtns.forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
      });
      focusFirstVisibleOpenButton();
    }
  }

  function initDrawerMenu() {
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-action="toggle-menu-open"]')) {
        event.preventDefault();
        setOpen(true);
        return;
      }

      if (event.target.closest('[data-action="toggle-menu-close"]')) {
        event.preventDefault();
        setOpen(false);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var drawer = getDrawer();
      if (!drawer || drawer.hasAttribute('hidden')) return;
      var readModal = document.getElementById('fc-readtxt-modal');
      if (readModal && !readModal.hasAttribute('hidden')) return;
      setOpen(false);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerMenu);
  } else {
    initDrawerMenu();
  }
})();
